/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockOrderCheckWithSkuInfoGoodsProcessVo
 */
export interface StockOrderCheckWithSkuInfoGoodsProcessVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    goodsId?: number;
    /**
     * 商品是否合包商品 0 否 1 是
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    combined?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    goodsCode?: string;
    /**
     * 商品skuid
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    skuId?: number;
    /**
     * 商品skucode
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    skuCode?: string;
    /**
     * 商品图片
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    goodsImg?: string;
    /**
     * 商品构成
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    constructQuantity?: number;
    /**
     * 快递单号
     * @type {Array<string>}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    trackingNumber?: Array<string>;
    /**
     * 申请数量
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    initQuantity?: number;
    /**
     * 商品颜色
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    goodsColor?: string;
    /**
     * 商品尺寸
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    goodsSize?: string;
    /**
     * 商品状态
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    goodsStatus?: number;
    /**
     * 商品状态名
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    goodsStatusName?: string;
    /**
     * 商品检查结果 0 正常 1 有误
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    checkResult?: number;
    /**
     * 商品少到数量
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    lessQuantity?: number;
    /**
     * 商品破损数量
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    damageQuantity?: number;
    /**
     * 商品有误数量
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    errorQuantity?: number;
    /**
     * 长
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    length?: number;
    /**
     * 宽
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    width?: number;
    /**
     * 高
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    height?: number;
    /**
     * 体积
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    cbm?: number;
    /**
     * 重量
     * @type {number}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    weight?: number;
    /**
     * 市场条码
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    marketBarcode?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    marketProNm?: string;
    /**
     * 市场选项名称
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    marketOptionName?: string;
    /**
     * 市场选项ID
     * @type {string}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    marketOptionId?: string;
    /**
     * 基础商品列表
     * @type {Array<StockOrderCheckWithSkuInfoGoodsProcessVo>}
     * @memberof StockOrderCheckWithSkuInfoGoodsProcessVo
     */
    children?: Array<StockOrderCheckWithSkuInfoGoodsProcessVo>;
}

/**
 * Check if a given object implements the StockOrderCheckWithSkuInfoGoodsProcessVo interface.
 */
export function instanceOfStockOrderCheckWithSkuInfoGoodsProcessVo(value: object): value is StockOrderCheckWithSkuInfoGoodsProcessVo {
    return true;
}

export function StockOrderCheckWithSkuInfoGoodsProcessVoFromJSON(json: any): StockOrderCheckWithSkuInfoGoodsProcessVo {
    return StockOrderCheckWithSkuInfoGoodsProcessVoFromJSONTyped(json, false);
}

export function StockOrderCheckWithSkuInfoGoodsProcessVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockOrderCheckWithSkuInfoGoodsProcessVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'goodsCode': json['goodsCode'] == null ? undefined : json['goodsCode'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'goodsImg': json['goodsImg'] == null ? undefined : json['goodsImg'],
        'constructQuantity': json['constructQuantity'] == null ? undefined : json['constructQuantity'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'goodsColor': json['goodsColor'] == null ? undefined : json['goodsColor'],
        'goodsSize': json['goodsSize'] == null ? undefined : json['goodsSize'],
        'goodsStatus': json['goodsStatus'] == null ? undefined : json['goodsStatus'],
        'goodsStatusName': json['goodsStatusName'] == null ? undefined : json['goodsStatusName'],
        'checkResult': json['checkResult'] == null ? undefined : json['checkResult'],
        'lessQuantity': json['lessQuantity'] == null ? undefined : json['lessQuantity'],
        'damageQuantity': json['damageQuantity'] == null ? undefined : json['damageQuantity'],
        'errorQuantity': json['errorQuantity'] == null ? undefined : json['errorQuantity'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(StockOrderCheckWithSkuInfoGoodsProcessVoFromJSON)),
    };
}

export function StockOrderCheckWithSkuInfoGoodsProcessVoToJSON(json: any): StockOrderCheckWithSkuInfoGoodsProcessVo {
    return StockOrderCheckWithSkuInfoGoodsProcessVoToJSONTyped(json, false);
}

export function StockOrderCheckWithSkuInfoGoodsProcessVoToJSONTyped(value?: StockOrderCheckWithSkuInfoGoodsProcessVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'combined': value['combined'],
        'goodsCode': value['goodsCode'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'goodsImg': value['goodsImg'],
        'constructQuantity': value['constructQuantity'],
        'trackingNumber': value['trackingNumber'],
        'initQuantity': value['initQuantity'],
        'goodsColor': value['goodsColor'],
        'goodsSize': value['goodsSize'],
        'goodsStatus': value['goodsStatus'],
        'goodsStatusName': value['goodsStatusName'],
        'checkResult': value['checkResult'],
        'lessQuantity': value['lessQuantity'],
        'damageQuantity': value['damageQuantity'],
        'errorQuantity': value['errorQuantity'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'cbm': value['cbm'],
        'weight': value['weight'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(StockOrderCheckWithSkuInfoGoodsProcessVoToJSON)),
    };
}

